import { getDotColor } from '@modules/members/utils/get-dot-color';
import { Badge } from 'antd';
import clsx from 'clsx';
import { RiGroupFill } from 'react-icons/ri';

type Props = {
  size: number;
  isOnline?: boolean;
  className?: string;
};

export function GroupAvatar({ size, isOnline, className }: Props) {
  const disc = (
    <span
      className={clsx('grid place-items-center rounded-full border border-gray-500 bg-surface shrink-0', className)}
      style={{ width: size, height: size }}
    >
      <RiGroupFill className="text-primary-500" style={{ width: (size * 4) / 9, height: (size * 4) / 9 }} />
    </span>
  );

  if (isOnline === undefined) return disc;

  return (
    <Badge dot style={{ backgroundColor: getDotColor(isOnline) }} offset={[-size * 0.16, size * 0.78]}>
      {disc}
    </Badge>
  );
}
